import { create } from 'zustand';

interface DoBoxTaskGroupSelectorState {
  isOpen: boolean;
}

interface DoBoxTaskGroupSelectorActions {
  open: () => void;
  close: () => void;
  toggle: () => void;
}

type DoBoxTaskGroupSelectorStore = DoBoxTaskGroupSelectorState &
  DoBoxTaskGroupSelectorActions;

export const useDoBoxTaskGroupSelectorStore =
  create<DoBoxTaskGroupSelectorStore>((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  }));
